import React, {useState, useRef, useEffect, Fragment} from 'react';

const SearchField = ({fieldLabel="CERCA", field="label"}) => {

const [searchValue, setSearchValue] = useState("");
const searchRef = useRef();

const searchFilter = (x) =>{
    // search-box
   const search =  x[field]?.toLowerCase()?.indexOf(searchValue.toLowerCase()) >= 0
   return search 
}
   //search-box
   const onSearchClick = (e) => {
    e.stopPropagation()
  };
  const onSearch = (e) => {
    setSearchValue(e.target.value);
  };

  return (
    <div>
             <h4>{"CERCA"}:</h4>
            <div className="search-box" style={{backgroundColor:"white", fontSize:"12px"}}>
                <input onClick={(e)=>onSearchClick(e)} style={{fontSize:"18px"}} onChange={onSearch} value={searchValue} ref={searchRef} />
            </div>
    </div>
  )
}

export default SearchField
